var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"justify-center"},[_c('v-col',{staticClass:"text-center mt-8",attrs:{"cols":"4"}},[_c('v-sheet',{staticClass:"py-5",attrs:{"elevation":"1"}},[_c('heart-loader'),_c('h4',{staticClass:"py-4"},[_vm._v("Logging you in...")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }